import PaymentsConfirmation from 'features/v2a/receiver/screens/PaymentsConfirmation/PaymentsConfirmation';
import React from 'react';

export default function Page() {
  return <PaymentsConfirmation />;
}
